/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { IPayersApiClient } from './contracts'
import { injectable } from 'inversify'
import { IPayer } from '../RequestHistoryStateManager/contracts'

@injectable()
export class MockPayersApiClient implements IPayersApiClient {
	getAllPayers(): Promise<IPayer[]> {
		return new Promise<IPayer[]>(resolve =>
			resolve([
				{ id: 1, name: 'Payer1', isSelected: false },
				{ id: 2, name: 'Payer2', isSelected: false },
				{ id: 3, name: 'Payer3', isSelected: false },
				{ id: 4, name: 'Payer4', isSelected: false },
				{ id: 5, name: 'Payer5', isSelected: false },
				{ id: 6, name: 'Payer6', isSelected: false },
				{ id: 7, name: 'Payer7', isSelected: false },
				{ id: 8, name: 'Payer8', isSelected: false },
				{ id: 9, name: 'Payer9', isSelected: false },
			]),
		)
	}
}
